module.exports = __webpack_public_path__ + "img/Pag3.df5814dd.png";